export { DocumentUrlPipe } from './document.url.pipe'
export { StaffPipe } from './staff.pipe'
export { SanitizePipe } from './sanitize.pipe'
export { PipesModule } from './pipes.module'
export { FilterMarkedForDeletion } from './filter.marked.for.deletion.pipe'


// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts